import { createSlice } from '@reduxjs/toolkit';
import { commonActs } from '../action';
import { showToast } from '@nxsys/utils/toast';
import { appIntl } from '@nxsys/helpers/Common';

export interface CommonState {
  uploadFile: {
    loading: boolean;
  }
}

const initialState: CommonState = {
  uploadFile: {
    loading: false,
  },
};

const commonSlice = createSlice({
  name: 'commonStore',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Upload file
    builder.addCase(commonActs.uploadFileToS3.pending, (state) => {
      state.uploadFile.loading = true;
    });
    builder.addCase(commonActs.uploadFileToS3.fulfilled, (state) => {
      state.uploadFile.loading = false;
    });
    builder.addCase(commonActs.uploadFileToS3.rejected, (state, action) => {
      state.uploadFile.loading = false;
      showToast({
        type: 'error',
        message:
          (action.payload as any)?.response?.data?.message ||
          appIntl().formatMessage({ id: 'common.uploadFile.error' }),
      });
    });
  }
});

export const commonReducer = commonSlice.reducer;
export const commonActions = {
  ...commonSlice.actions,
  ...commonActs,
};
